import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { posthog } from "@/lib/posthog";

export const StickyMobileCTA = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      // Show after 50% scroll, hide when form is in view
      const formElement = document.getElementById("waitlist-form");
      const formInView = formElement && formElement.getBoundingClientRect().top < window.innerHeight;
      
      setIsVisible(scrollPercentage > 50 && !formInView);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToForm = () => {
    const formElement = document.getElementById("waitlist-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }

    // PostHog tracking
    if (posthog.__loaded) {
      posthog.capture('sticky_cta_clicked', { 
        device: 'mobile',
        location: 'sticky_bar'
      });
    }

    // GTM tracking
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'cta_click',
        cta_location: 'sticky_mobile',
      });
    }
  };

  return (
    <div
      className={`
        fixed bottom-0 left-0 right-0 z-50 
        md:hidden
        bg-background/95 backdrop-blur-sm border-t border-border
        transition-transform duration-300 shadow-2xl
        ${isVisible ? "translate-y-0" : "translate-y-full"}
      `}
    >
      <div className="container mx-auto p-4">
        <Button
          onClick={scrollToForm}
          size="lg"
          className="w-full"
        >
          {t("hero.cta")}
        </Button>
      </div>
    </div>
  );
};
